import { LocaleEnum } from '@systemeio/ui'

export const getXenditHelpPageLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DUTCH: {
      return 'https://help-nl.systeme.io/article/2287-hoe-je-xendit-integreert-met-systeme-io'
    }
    case LocaleEnum.DEUTSCH: {
      return 'https://help-de.systeme.io/article/2314-so-integrieren-sie-xendit-in-systemeio'
    }
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/2222-comment-integrer-xendit-a-systeme-io'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://help-jp.systeme.io/article/2350-how-to-integrate-xendit-with-systeme-io'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://help-pt.systeme.io/article/2503-como-integrar-o-xendit-com-a-systeme-io'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/2303-como-integrar-xendit-con-systeme-io'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/2251-come-integrare-xendit-con-systeme-io'
    }
    default: {
      return 'https://help.systeme.io/article/2225-how-to-integrate-xendit-with-systeme-io'
    }
  }
}
